import {authRoles} from 'app/auth';
import React from 'react';

export const ZReportAppConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.staff,
    routes  : [
        {
            path     : '/zreports',
            component: React.lazy(() => import('./ZReportApp'))
        },
    ]
};
